import type { NavItem } from '../types/content'

/** Barre utilitaire, au-dessus du menu principal. */
export const utilityLinks: { label: string; to?: string }[] = [
  { label: 'Espace citoyen', to: '/mon-espace' },
  { label: 'Nouvelles' },
  { label: 'Avis publics', to: '/notifications' },
  { label: 'Carte interactive', to: '/plan' },
  { label: 'Contact' },
]

export const navItems: NavItem[] = [
  {
    label: 'La ville',
    children: [
      'Découvrir Windsor',
      'Mairie',
      'Séances ordinaires',
      'Organisation municipale',
      'Développement économique',
    ],
  },
  {
    label: 'Services',
    children: [
      'Travaux publics',
      'Info-travaux',
      'Traitement des eaux',
      'Matières résiduelles',
      'Règlements municipaux',
      'Permis et inspection',
      'Finances, taxes et évaluation',
      'Régie intermunicipale d’incendie',
    ],
  },
  {
    label: 'Loisirs',
    children: [
      'Activités',
      'Bibliothèque Patrick-Dignan',
      'Piscine municipale et jeux d’eau',
      'Centre sportif J.A. Lemay',
      'Centre communautaire',
    ],
  },
  {
    label: 'Services numériques',
    children: [
      'bciti+ Services numériques',
      'Espace citoyen',
      'Accès à l’information',
      'Avis publics',
      'Offres d’emploi',
    ],
  },
  { label: 'Demande de permis', children: [] },
  { label: '150e', children: [] },
]
